export default function CTASection() {
  return (
    <section className="py-16 bg-accent-500 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Japanese%20wave%20pattern%20seamless%20texture%2C%20soft%20cream%20and%20warm%20beige%20colors%2C%20traditional%20Japanese%20seigaiha%20wave%20motif%2C%20subtle%20elegant%20pattern%2C%20clean%20simple%20design%2C%20minimal%20aesthetic&width=1400&height=400&seq=cta-pattern&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          aria-hidden="true"
        />
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl text-white mb-3">
          开启你的漫画之旅
        </h2>
        <p className="text-white/80 text-base md:text-lg mb-8 max-w-[500px] mx-auto">
          樱花动漫91提供漫画全集下拉式阅读体验，海量在线漫画资源，好看的漫画免费看
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="/category/lianai"
            className="px-8 py-3 bg-white text-accent-600 rounded-full text-sm font-medium hover:bg-white/90 transition-colors duration-200 whitespace-nowrap"
          >
            立即阅读
          </a>
          <a
            href="/about"
            className="px-8 py-3 bg-white/15 text-white rounded-full text-sm font-medium hover:bg-white/25 transition-colors duration-200 whitespace-nowrap"
          >
            了解更多
          </a>
        </div>
      </div>
    </section>
  );
}